/**
 * @generated SignedSource<<ac12d4f127cf98ff2ebdb6da28e712f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MessageDirection = "INCOMING" | "OUTGOING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Message_message$data = {
  readonly author: {
    readonly displayName: string | null | undefined;
    readonly photoURL: string | null | undefined;
  };
  readonly content: string;
  readonly direction: MessageDirection;
  readonly formattedDate: string | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "Message_message";
};
export type Message_message$key = {
  readonly " $data"?: Message_message$data;
  readonly " $fragmentSpreads": FragmentRefs<"Message_message">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Message_message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": "formattedDate",
      "args": [
        {
          "kind": "Literal",
          "name": "format",
          "value": "dddd DD MMM yyyy"
        }
      ],
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": "createdAt(format:\"dddd DD MMM yyyy\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "direction",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "photoURL",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Message",
  "abstractKey": null
};

(node as any).hash = "4acf89495313988781a37c4f1ada75c1";

export default node;
